import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'umi';
import { Button, Layout, H2, notification } from 'tea-component';
import Chat from '@/pages/datalab/pages/BehaviorAnalysis/GptAnalysis/Chat';
import QuestionList from '@/pages/datalab/pages/BehaviorAnalysis/GptAnalysis/components/QuestionList';
import HowItWorks from '@/pages/datalab/pages/BehaviorAnalysis/GptAnalysis/components/HowItWorks';
import Faq from '@/pages/datalab/pages/BehaviorAnalysis/GptAnalysis/components/Faq';
import Notes from '@/pages/datalab/pages/BehaviorAnalysis/GptAnalysis/components/Notes';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { useDblIntl } from '@/pages/datalab/utils/utils';
import { buriedPoint } from '@/pages/home/utils/buriedPoint';
import { formatNum } from '@/pages/dashboard/utils/utils';
import useChatReduce from '@/pages/datalab/pages/BehaviorAnalysis/GptAnalysis/useChatReduce';
import './index.scss';
import { useBoolean } from 'ahooks';

const { Content } = Layout;

function ChatApp() {
  const { state, dispatch } = useChatReduce();
  const { messages, isComplete } = state;
  const {
    dblFormatMessage: gptFormatMessage,
    // commonFormatMessage,
    isEn,
  } = useDblIntl('gpt');
  const { gameCode } = useSelector((state) => ({
    gameCode: state.datalab.gameCode || 'demo',
  }));
  const [answerCount, setAnswerCount] = useState(0);
  const [isHome, setIsHome] = useState(true);
  // const insightFetchCount = useRef<number>(0);
  // const chartInfoLength = useRef<number>(0);
  const [analysisInitialStateText, { setFalse }] = useBoolean(false);
  const times=useRef();
  const handleBuriedPoint = () => {
    buriedPoint({
      pageId: '600701',
      pageName: 'Chat BI',
      extInfo: `{"pageName": "Chat BI", "pageNameCn": "Chat BI", "id": ""}`,
      pagePath: '/Action/GptAnalysis',
      uid: gameCode,
      menuId: '0',
      typeId: 'datalab_pc_v2',
    });
  };
  useEffect(() => {
    times.current=setTimeout(() => {
      handleBuriedPoint();
    }, 600);
    return ()=>{
      clearTimeout(times.current);
    };
  }, [gameCode]);

  useEffect(() => {
    // 切换游戏和页面的时候重置数据
    handleClear(true);
    return () => {
      handleClear(true);
    };
  }, [gameCode]);

  const handleClear = useCallback(
    (isHome) => {
      dispatch({ type: 'RESET' });
      !isComplete && cancelTask();
      setIsHome(isHome);
    },
    [isComplete],
  );
  const cancelTask = useCallback(() => {
    dispatch({ type: 'CANCEL_TASK' });
    notification.success({
      className: 'downDataBox downData',
      description: isEn ? 'Stop automatic analysis' : '停止自动分析',
      duration: 3000,
    });
  }, [isEn]);

  const sendMessage = useCallback(
    (value: string) => {
      isHome && setIsHome(false);
      setFalse();
      // 更新页面上的消息显示
      dispatch({ type: 'ADD_RIGHT_MESSAGE', payload: { content: value } });
      // 发起任务分析请求
      state.results.push({
        role: 'user',
        content: value,
      });
      dispatch({
        type: 'FETCH_MESSAGE',
        payload: {
          gameCode,
          question: value,
          language: isEn ? 'en' : 'zh',
          domain: `${location.origin}/`,
          messages: state.results,
          data: state.chartInfo,
        },
      });
    },
    [state.results],
  );
  // TODO:analyze服务接口暂时下了，chatBI不支持，
  // 如果chartInfo存在的话，说明是拉到了图表数据，需要发起数据分析接口，获取新数据
  // 这里使用这个hook的作用主要是用作于在请求流式中，我们的状态是不可变的，视图一直在渲染，在走diff流程，这里针对副作用进行防抖，优化性能
  // useDebounceEffect(
  //   () => {
  //     // 如果用户开始对话，并且数据返回图表类型，这里的计数器reset
  //     if (!isEmpty(state.chartInfo)) {
  //       insightFetchCount.current = 0;
  //     }
  //     // 如果用户对话的类型只是普通的文本等，将不会返回charInfo等信息,这里的图表计算器reset
  //     if (isEmpty(state.chartInfo)) {
  //       chartInfoLength.current = 0;
  //     }
  //     // 在依次判断每次新增图表的长度是否和本次轮询的长度一致，这里的作用主要是用于只有chartInfo存在的情况下，需要调接口，并且只调一次
  //     if ((!isEmpty(state.chartInfo) && state.chartInfo.length === chartInfoLength.current + 1)) {
  //       // 后端要求如果url为空等，不需要report,这里需要判断一下，如果其中一个属性没有值，就不发起请求
  //       const allObjectsHaveValues = state.chartInfo
  //         .slice(-1)
  //         .every(({ title, url }) => title && url);
  //       if (!allObjectsHaveValues) return;
  //       insightFetchCount.current++;
  //       if (insightFetchCount.current > 1) {
  //         return;
  //       }
  //       chartInfoLength.current = state.chartInfo.length;
  //       dispatch({ type: "TASK_STATE", payload: false });
  //       setTrue();
  //       dispatch({
  //         type: 'FETCH_MESSAGE',
  //         payload: {
  //           gameCode,
  //           question: state.chartInfo.slice(-1)?.[0].title,
  //           language: isEn ? 'en' : 'zh',
  //           domain: `${location.origin}/`,
  //           messages: state.results,
  //           data: state.chartInfo,
  //           url: '/api/v1/datalab/analyze',
  //         },
  //       });
  //     }
  //   },
  //   [state],
  //   {
  //     wait: 300,
  //   },
  // );
  return (
    <Content className={'dbl-gpt'}>
      <Content.Header
        title={gptFormatMessage('title')}
        operation={
          <div>
            {isHome ? (
              ''
            ) : (
              <Button
                className={'btn'}
                type="weak"
                onClick={() => handleClear(false)}
              >
                <SvgIcon type="datalab-clear" />
                {gptFormatMessage('clear')}
              </Button>
            )}
          </div>
        }
        showBackButton={!isHome}
        onBackButtonClick={() => handleClear(true)}
      />
      <Content.Body full>
        <div
          className={isHome ? 'dbl-gpt-home-top ' : 'dbl-gpt-home-hidden'}
          style={{ width: isEn ? '616px' : '295px' }}
        >
          <H2>{gptFormatMessage('home_top_title')}</H2>
          <p
            dangerouslySetInnerHTML={{
              __html: gptFormatMessage('home_top_des', {
                count: formatNum(answerCount),
              }),
            }}
          />
        </div>
       
        <Chat
          onSend={(value: string) => {
            sendMessage(value);
          }}
          onStop={() => {
            cancelTask();
          }}
          messages={messages}
          isThinking={!isComplete}
          className={isHome ? 'no-messages' : ''}
          initialLoadingText={analysisInitialStateText}
        />
        {isHome ? (
          <div className={'dbl-gpt-home'}>
            <div className={'dbl-gpt-home-row'}>
              <QuestionList
                clickQuestion={(question: string) => {
                  sendMessage(question);
                }}
                getAnswerCount={(count: number) =>
                  count !== answerCount && setAnswerCount(count)
                }
              />
              <div className="dbl-gpt-home-riginfo">
                <Notes />
                <HowItWorks />
              </div>
            </div>
            <Faq />
          </div>
        ) : (
          ''
        )}
      </Content.Body>
    </Content>
  );
}

export default ChatApp;
